import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {FileManager} from "../interface/file-manager";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {DOCUMENT} from "@angular/common";
import {Tag} from "../interface/tag";
import {ListResponse} from "../interface/response/list-response";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class FileManagerService {
  private readonly fileManagerListSubject: ReplaySubject<CountedAndPaginated<FileManager>>
    = new ReplaySubject<CountedAndPaginated<FileManager>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public getFileManagerListSubject(): ReplaySubject<CountedAndPaginated<FileManager>> {
      return this.fileManagerListSubject;
    }

  public loadList(filters: object , page: number, pageSize: number,  sort?: { sortBy?: string; sortOrder?: string}): void {
      this.httpClient.get(`/rest/crm/file-manager?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
        .pipe(
          first()
        )
        .subscribe((result: CountedAndPaginated<FileManager>) => {
          this.fileManagerListSubject.next(result);
        });
    }

  public sendCatalog(formData: object, uuid?: string): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/file-manager/catalog/${uuid}`, formData)
          .pipe(
              take(1)
          ) as Observable<Uuid>;
    } else {
      return this.httpClient.post(`/rest/crm/file-manager/catalog`, formData)
          .pipe(
              take(1)
          );
    }
  }

  public sendFile(formData: object, uuid?: string): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/file-manager/file/${uuid}`, formData)
          .pipe(
              take(1)
          ) as Observable<Uuid>;
    } else {
      return this.httpClient.post(`/rest/crm/file-manager/file`, formData)
          .pipe(
              take(1)
          );
    }
  }

  public sendPage(formData: object, pageId: string): Observable<any> {
    if (!pageId) {
      return this.httpClient.post(`/rest/crm/file-manager/page`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm/file-manager/page/${pageId}`, formData)
        .pipe(take(1));
    }
  }

  public downloadFile(uuid: string): void{
    this.document.location.href = `/rest/crm/file-manager/file/${uuid}/downloadFile`;
  }

  public deleteFile(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/file-manager/file/${uuid}`)
      .pipe(first());
  }
  public deleteCatalog(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/file-manager/catalog/${uuid}`)
      .pipe(first());
  }

  public updateOrder(updatedItems: any): Observable<any> {
      return this.httpClient.put(`/rest/crm/file-manager/reorder`, {updatedItems})
        .pipe(take(1));
  }
}
